import { useQuery } from "@tanstack/react-query";
import { fetchCrafts } from "../repositories/CraftsRepository";

export const CRAFTS_QUERY_KEYS = {
	all: ["crafts"] as const,
};

export const useCrafts = () => {
	const query = useQuery({
		queryKey: CRAFTS_QUERY_KEYS.all,
		queryFn: fetchCrafts,
	});

	return {
		crafts: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error as Error | null,
	};
};
